import { createAction, props } from '@ngrx/store';
import { ITaxNumbersResponse, ITaxNumber, ITaxNumberSaveResponse } from '../models/tax-numbers.model';

export const loadTaxNumbers = createAction(
  '[ProductDetails] Load Tax Numbers',
  props<{ customerId: string }>()
);

export const loadTaxNumbersSuccess = createAction(
  '[ProductDetails] Load Tax Numbers Success',
  props<{ response: ITaxNumbersResponse }>()
);

export const loadTaxNumbersFailure = createAction(
  '[ProductDetails] Load Tax Numbers Failure',
  props<{ error: Error | any }>()
);

export const saveTaxNumber = createAction(
  '[TaxNumbers] Save Tax Number',
  props<{ customerId: string, taxNumber: ITaxNumber }>()
);

export const saveTaxNumberSuccess = createAction(
  '[TaxNumbers] Save Tax Number Success',
  props<{ response: ITaxNumberSaveResponse }>()
);

export const saveTaxNumberFailure = createAction(
  '[TaxNumbers] Save Tax Number Failure',
  props<{ error: any }>()
);